import Axios from "axios";

class UsuarioNotificacaoDataService {
  findMyRecords() {
    return Axios.get("/usuarioNotificacao");
  }

  marcarComoLida(id) {
    return Axios.put(`/usuarioNotificacao/${id}/lida`);
  }

  marcarTodasComoLidas() {
    return Axios.put("/usuarioNotificacao/lida/todas");
  }
}

export default new UsuarioNotificacaoDataService();
